
    var riot = require('riot')
    
riot.tag2('client-quote', '<gdpr if="{opts.quote.contact}" user="{opts.quote.contact}"></gdpr> <div class="row"> <div class="col-xs-12"> <h3>Quote {opts.quote.id}</h3> <div each="{item,i in items}" class="row {i % 2 == 0 ? \'greybg\' : \'\'}"> <div class="col-xs-12"> <div class="wrapper"> <div class="row flexrow"> <div class="col-xs-12 col-md-8"> <div class="row"> <div class="col-xs-12 col-md-3 col-lg-2"> <div class="cell celltop"><strong>Title</strong></div> </div> <div class="col-xs-12 col-md-9 col-lg-10"> <div class="cell cellbottom">{item.title}</div> </div> <hr class="underline"> </div> <div class="row"> <div class="col-xs-12 col-md-3 col-lg-2"> <div class="cell celltop"><strong>Description</strong></div> </div> <div class="col-xs-12 col-md-9 col-lg-10"> <div riot-tag="raw" content="{item.description_text}" class="cell cellbottom"></div> </div> <hr class="underline visible-xs"> </div> </div> <div class="col-xs-12 col-md-4 padding-bottom"> <div class="row"> <div class="col-xs-5"> <div class="cell celltop"><strong>Quantity</strong></div> </div> <div class="col-xs-7"> <div class="cell cellbottom">{item.quantity}</div> </div> <hr class="underline"> </div> <div class="row"> <div class="col-xs-5"> <div class="cell celltop"><strong>Price</strong></div> </div> <div class="col-xs-7"> <div class="cell cellbottom">&pound;{item.price} <small>(+VAT)</small></div> </div> </div> <div class="blueblock"> <input type="checkbox" name="{item.id}" onclick="{confirmItem}" id="cbx{i}"> <label for="cbx{i}"><i></i>Confirm</label> </div> </div> </div> </div> </div> </div><br><br> <h3>Your Notes<span>&nbsp; - any additional info regarding this quote</span></h3> <form class="form-horizontal"> <div class="col-xs-12"> <div class="grey"> <div class="form-group"> <textarea placeholder="Notes..." name="notes" oninput="{setnotes}" class="form-control"></textarea> </div> </div> </div> </form> </div> </div> <div class="row"> <div class="col-xs-12 text-right"> <div class="form-group {showTermsError ? \'has-error\' : \'\'}"> <div class="checkbox"> <input type="checkbox" name="Terms" onclick="{updateTerms}" id="terms"> <label for="terms">Please tick to confirm our <a href="/terms_and_conditions" target="_blank">Terms and Conditions</a></label> </div> </div> </div> </div> <div class="row"> <div class="col-xs-12 text-right"> <button type="submit" onclick="{submit}" if="{confirmedItems.length == 0}" class="btn btn-primary">Submit</button> <button type="submit" onclick="{submit}" if="{confirmedItems.length &gt; 0}" class="btn btn-primary">Place Order</button> </div> </div>', '.checkbox label { padding-left: 0; } .checkbox input[type="checkbox"] { margin: 2px 0 0 -20px; } .has-error a { color: #f00; } hr.underline { margin: 0 15px; padding: 1px; display: block; border-color: rgba(0,0,0,0.05); width: calc(100% - 30px); } h3 span { font-size: 90%; font-weight: normal; } .flexrow { margin-bottom: 15px; display: flex; flex: 1; } .cell { padding: 8px 15px; } .greybg .wrapper { background: #f9f9f9; } .blueblock { background: #78c8ce; width: calc(100% - 30px); position: absolute; bottom: 0; padding: 8px 15px; color: #fff; font-size: 21px; text-align: right; } .flex { display: flex; flex: 1; align-items: stretch; height: 100%; } .grey textarea { background: #eee; } .padding-bottom { padding-bottom: 55px; } .padding-bottom input[type="checkbox"] + label { color: #fff !important; font-size: 20px; display: inline-block; position: relative; min-height: 1.7em; line-height: 1.7em; vertical-align: middle; cursor: pointer; padding: 0; } .padding-bottom input[type="checkbox"] + label i:before { display: inline-block; position: relative; width: 16px; height: 16px; margin-right: 20px; background-color: #fff; font-style: normal; vertical-align: middle; content: ""; } .padding-bottom input[type="checkbox"]:checked + label i:before { color: #78c8ce; font-family: "ElegantIcons"; font-size: 15px; line-height: 19px; text-align: center; font-weight: bold; content: "\\4e"; } .padding-bottom input[type="checkbox"] { display: none; } @media (max-width: 991px) { .flexrow { display: block; flex: 0; margin-left: -15px; margin-right: -15px; } .blueblock { position: relative; width: 100%; } div[class*=\'col-\'] { padding-left: 15px; padding-right: 15px; } .celltop { padding-bottom: 0; } .padding-bottom { padding-bottom: 0; } }', '', function(opts) {
var quoteApi, resource;

resource = require('riot-kit/utils/apiResource.coffee');

quoteApi = new resource('/duocms/api/quotes', true);

this.on('mount', function() {
  this.terms = false;
  this.showTermsError = false;
  this.confirmedItems = [];
  this.notes = "";
  this.items = opts.quote.items.map(function(i) {
    var ref;
    return Object.assign(i, {
      description_text: (ref = i.description) != null ? ref.replace(/[\n\r]/g, '<br/>') : void 0
    });
  });
  return this.update();
});

this.submit = function() {
  if (!this.terms) {
    this.showTermsError = true;
    this.update();
    return;
  }
  return quoteApi.save({
    id: opts.quote.id,
    items: this.confirmedItems,
    notes: this.notes
  }, function(data, err) {
    if (err != null) {
      console.log('err', err);
    }
    if (err == null) {
      window.location.pathname = '/client_quote/thank_you';
    }
    return null;
  });
};

this.updateTerms = function(e) {
  this.showTermsError = false;
  return this.terms = e.target.checked;
};

this.setnotes = function(e) {
  return this.notes = e.target.value;
};

this.confirmItem = function(e) {
  if (e.target.checked) {
    return this.addConfirmed(e.target.name);
  } else {
    return this.removeConfirmed(e.target.name);
  }
};

this.addConfirmed = function(id) {
  return this.confirmedItems.push(id);
};

this.removeConfirmed = function(id) {
  if (this.confirmedItems.indexOf(id) > -1) {
    return this.confirmedItems.splice(this.confirmedItems.indexOf(id), 1);
  }
};
});
    
  